<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open()"
               :append-to-body="true"
               width="700px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">

        <el-form-item label="院校名称"
                      prop="college"
                      v-if="title == '编辑学制'">
          <el-select v-model="dataForm.college"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="collegeChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="专业名称"
                      prop="major">
          <el-select v-model="dataForm.major"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="majorChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in majorList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学院名称"
                      prop="academy">
          <el-select v-model="dataForm.academy"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="academyChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in academylist"
                       :key="index"
                       :label="item.academy_name"
                       :value="{
                      value: item.academy_code,
                      label: item.academy_name,
                      directions: item.directions,
                    }">
              <span>{{
                `（${item.academy_code}）${item.academy_name}`
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="方向名称"
                      prop="direction">
          <el-select v-model="dataForm.direction"
                     filterable
                     clearable
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in directionlist"
                       :key="index"
                       :label="item.direction"
                       :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
              <span>{{
                `（${item.direction_code}）${item.direction}`
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学习方式"
                      prop="enrol_type">
          <el-select v-model="dataForm.enrol_type"
                     clearable
                     placeholder="请选择"
                     style="width: 100%">
            <el-option label="全日制"
                       :value="1">
            </el-option>
            <el-option label="非全日制"
                       :value="2">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学制"
                      prop="learn_span">
          <el-input v-model="dataForm.learn_span"
                    placeholder="请输入学制，如 3年"></el-input>
        </el-form-item>
      </el-form>
      <div class="footers">
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  learnSpanCreated,
  learnSpanDetail,
  learnSpanPut,
} from '@/api/admission'
import { collegeMajorList, majorinfo } from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: () => {
        return '新建学制'
      },
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      rules: {
        college: [
          { required: true, message: '请选择院校', trigger: 'change' },
        ],
        major: [
          { required: true, message: '请选择专业', trigger: 'change' },
        ],
        academy: [
          { required: true, message: '请选择学院', trigger: 'change' },
        ],
        enrol_type: [
          { required: true, message: '请选择学习方式', trigger: 'change' },
        ],
        learn_span: [
          { required: true, message: '请输入学制', trigger: 'blur' },
        ],
      },
      dataForm: {
        college: {},
        major: {},
        academy: {},
        direction: {},
        enrol_type: '',
        learn_span: '',
      },
      rowDetail: {},
      majorList: [],
      academylist: [],
      directionlist: [],
    }
  },

  methods: {
    // 编辑时院校变化 → 重置专业/学院/方向并加载专业列表
    collegeChange(e) {
      this.$set(this.dataForm, 'major', {})
      this.$set(this.dataForm, 'academy', {})
      this.$set(this.dataForm, 'direction', {})
      this.academylist = []
      this.directionlist = []
      this.fetchMajor(e.value)
    },
    // 专业下拉数据（新增时按父级院校加载）
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },
    // 专业变化 → 加载学院/方向（分数线同款三级联动）
    majorChange(e) {
      this.$set(this.dataForm, 'academy', {})
      this.$set(this.dataForm, 'direction', {})
      this.directionlist = []
      this.fetchMajorInfo(this.dataForm.college.value, e.value)
    },
    fetchMajorInfo(college_code, major_code) {
      return new Promise((resolve) => {
        majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
          this.academylist = res.academys
          resolve(res)
        })
      })
    },
    // 学院变化 → 设置方向列表
    academyChange(e) {
      this.$set(this.dataForm, 'direction', {})
      this.directionlist = e.directions || []
    },
    handleClose() {
      this.$emit('close')
      this.dataForm = {
        college: {},
        major: {},
        academy: {},
        direction: {},
        enrol_type: '',
        learn_span: '',
      }
      this.majorList = []
      this.academylist = []
      this.directionlist = []
      this.$refs['dataForm'].resetFields()
    },
    open() {
      if (this.title == '新建学制') {
        // 新增：院校由父级带入作为默认值（仅用于联动传参，界面不显示）
        this.$set(this.dataForm, 'college', {
          value: this.detail.college_code,
          label: this.detail.college_name,
        })
        this.fetchMajor(this.detail.college_code)
      } else {
        // 编辑：回显 院校/专业/学院/方向/学习方式/学制
        learnSpanDetail({ id: this.rowId }).then((res) => {
          this.rowDetail = res
          this.$set(this.dataForm, 'learn_span', res.learn_span)
          this.$set(this.dataForm, 'enrol_type', Number(res.enrol_type))
          // 院校/专业/学院/方向
          this.$set(this.dataForm, 'college', {
            value: res.college_code,
            label: res.college_name,
          })
          this.$set(this.dataForm, 'major', {
            value: res.major_code,
            label: res.major_name,
          })
          this.$set(this.dataForm, 'academy', {
            value: res.academy_code,
            label: res.academy_name,
          })
          this.$set(this.dataForm, 'direction', {
            value: res.direction_code,
            label: res.direction_name,
          })
          // 按回显院校加载专业列表
          this.fetchMajor(res.college_code)
          // 按 院校+专业 加载学院/方向（=== 匹配当前行学院，兜底方向）
          this.fetchMajorInfo(res.college_code, res.major_code).then(
            (info) => {
              const academys = info.academys || []
              const target = academys.find(
                (v) => v.academy_code === res.academy_code
              )
              if (target && Array.isArray(target.directions)) {
                this.directionlist = target.directions
              } else if (res.direction_code) {
                this.directionlist = [
                  {
                    direction_code: res.direction_code,
                    direction: res.direction_name,
                  },
                ]
              } else {
                this.directionlist = []
              }
            }
          )
        })
      }
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.title == '新建学制') {
            let data = {
              year: this.detail.current_search_year,
              college_code: this.detail.college_code,
              college_name: this.detail.college_name,
              academy_code: this.dataForm.academy.value,
              academy_name: this.dataForm.academy.label,
              major_code: this.dataForm.major.value,
              major_name: this.dataForm.major.label,
              direction_code: this.dataForm.direction.value,
              direction_name: this.dataForm.direction.label,
              enrol_type: this.dataForm.enrol_type,
              learn_span: this.dataForm.learn_span,
            }
            learnSpanCreated(data).then(() => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`操作成功`)
            })
          } else {
            let data = {
              id: this.rowId,
              year: this.detail.current_search_year,
              college_code: this.dataForm.college.value,
              college_name: this.dataForm.college.label,
              academy_code: this.dataForm.academy.value,
              academy_name: this.dataForm.academy.label,
              major_code: this.dataForm.major.value,
              major_name: this.dataForm.major.label,
              direction_code: this.dataForm.direction.value,
              direction_name: this.dataForm.direction.label,
              enrol_type: this.dataForm.enrol_type,
              learn_span: this.dataForm.learn_span,
            }
            learnSpanPut(data).then(() => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`修改成功`)
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footers {
  display: flex;
  justify-content: flex-end;
}
</style>
